export interface Dictionary<T> {
    [Key: string]: T;
}

export class Utilities {

    static stringIsNullOrWhitespace(value: string | any) {
        if (value === null || value === undefined) {
            return true;
        }
        else if (typeof value !== 'string') {
            value = value.toString();
        }
        return (value.trim().length === 0);
    }

    static isValidEmail(email) {
        // tslint:disable-next-line:max-line-length
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    static cleanUrl(url: string) {
        return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
    }

    static async resizeImage(imageFile: Blob, maxWidth: number, maxHeight: number, orientation: number = 1) {
        return new Promise((resolve, reject) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = document.createElement('img');

            img.onload = (data => {
                const iw = img.width;
                const ih = img.height;
                const maxW = Math.min(maxWidth, iw);
                const maxH = Math.min(maxHeight, ih);
                const scale = Math.min((maxW / iw), (maxH / ih));
                const iwScaled = iw * scale;
                const ihScaled = ih * scale;
                canvas.width = iwScaled;
                canvas.height = ihScaled;

                // set proper canvas dimensions before transform & export
                if (4 < orientation && orientation < 9) {
                    canvas.width = ihScaled;
                    canvas.height = iwScaled;
                } else {
                    canvas.width = iwScaled;
                    canvas.height = ihScaled;
                }

                // transform context before drawing image
                switch (orientation) {
                    case 2:
                        // horizontal flip
                        ctx.translate(iwScaled, 0);
                        ctx.scale(-1, 1);
                        break;
                    case 3:
                        // 180° rotate left
                        ctx.translate(iwScaled, ihScaled);
                        ctx.rotate(Math.PI);
                        break;
                    case 4:
                        // vertical flip
                        ctx.translate(0, ihScaled);
                        ctx.scale(1, -1);
                        break;
                    case 5:
                        // vertical flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.scale(1, -1);
                        break;
                    case 6:
                        // 90° rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(0, -ihScaled);
                        break;
                    case 7:
                        // horizontal flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(iwScaled, -ihScaled);
                        ctx.scale(-1, 1);
                        break;
                    case 8:
                        // 90° rotate left
                        ctx.rotate(-0.5 * Math.PI);
                        ctx.translate(-iwScaled, 0);
                        break;
                    default: // 1 do nothing
                        break;
                }

                ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
                canvas.toBlob(blob => {
                    resolve(URL.createObjectURL(blob));
                }, imageFile.type, 0.75);
            });

            img.src = URL.createObjectURL(imageFile);
        });
    }

    static base64ToBlob(b64: string) {
        // convert base64 to raw binary data held in a string
        const byteString = atob(b64.split(',')[1]);

        // separate out the mime component
        const mimeString = b64.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        const bb = new Blob([ab], { type: mimeString });
        return bb;
    }

    static getBase64FromDataUrl(dataUrl: string) {
        return new Promise<string>((resolve, reject) => {
            fetch(dataUrl, { mode: 'cors' }).then(r => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result as string);
                };
                r.blob().then(blob => {
                    reader.readAsDataURL(blob);
                });
            });
        });
    }

    static downloadBlob(file: Blob, saveAs: string) {
        // Generate a download link using the blob as the data
        const link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.setAttribute('visibility', 'hidden');
        link.download = saveAs;

        // Add the link to the dom, click it to trigger dl, then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    static downloadFromBase64(base64: string, saveAs: string) {
        // Convert the base64 to a blob file, then run the download blob function
        const blob = this.base64ToBlob(base64);
        this.downloadBlob(blob, saveAs);
    }

    static generateUuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static async initMapsAutoComplete(elementId: string, objWithAdd: any, objAddrProperty: string) {

        try {

            async function initPlaces(): Promise<void> {
                //@ts-ignore
                const x = await google.maps.importLibrary("places");
            }
            await initPlaces();

            const input = document.getElementById(elementId) as HTMLInputElement;
            console.log('Found map input', input);

            const options = {
                componentRestrictions: { country: ['ca', 'us'] },
                //fields: ['address_components', 'geometry', 'icon', 'name'],
                strictBounds: false,
                types: ['locality'] //['(regions)'],
            };

            const autocomplete = new google.maps.places.Autocomplete(input, options);
            autocomplete.addListener('place_changed', () => {
                objWithAdd[objAddrProperty] = input.value;
            });
        } catch (e) {
            console.log('Error initMapsAutoComplete', e);
        }
    }

    static async wait(ms) {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    }
}
